import React from 'react';
import { ArrowUpTrayIcon } from '@heroicons/react/24/outline';

interface ChiffHeaderProps {
  title?: string;
  description?: string;
  onImport?: () => void;
  isImporting?: boolean;
}

const ChiffHeader: React.FC<ChiffHeaderProps> = ({
  title = "Chiffrage",
  description = "Constituer un chiffrage en sélectionnant des ouvrages",
  onImport,
  isImporting = false,
}) => {
  return (
    <header className="mb-8">
      <div className="flex justify-between items-start">
        <div>
          <h1 className="text-3xl font-bold text-violet-700 leading-tight">{title}</h1>
          <p className="mt-2 text-base text-gray-600">{description}</p>
        </div>
        <div className="flex items-center gap-3">
          <button
            onClick={onImport}
            disabled={isImporting}
            className={`flex items-center gap-2 px-4 py-2 text-sm font-semibold rounded-lg transition-all duration-200 shadow-sm ${
              isImporting
                ? 'bg-violet-300 text-white cursor-not-allowed'
                : 'bg-violet-600 text-white hover:bg-violet-700 hover:shadow-md active:scale-95'
            }`}
          >
            <ArrowUpTrayIcon className="w-4 h-4" />
            <span className="tracking-wide">IMPORTER</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default ChiffHeader;
